import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=017fa724&scoped=true&"
import script from "./forgot-password.vue?vue&type=script&lang=js&"
export * from "./forgot-password.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=017fa724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017fa724",
  null
  
)

export default component.exports